import React from "react";
import style1 from "../../sass/showNavList.module.scss";
import NavList from "./NavList";
import style from "../../sass/navigation.module.scss";

const ShowNavList = () => {
     return (
          <div className={style1.showNavList}>
               <nav className={style.navigation} id={style1.navigation}>
                    <ul className={style["navigation-items"]} id={style1.navList}>
                         <NavList />
                    </ul>
               </nav>
          </div>
     );
};
export default ShowNavList;
